

const FactorsFiltersComponent = ({ filters, setFilters }) => {

    const hadleChange = (e) => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12 p-3">
                    <div className="form-group">
                        <div className="card p-3">
                            <label className="form-label">Factor</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Factor"
                                value={filters?.factor}
                                onChange={hadleChange}
                                name="factor"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FactorsFiltersComponent;